import { LANG } from '@/common/constants/language';
import {
  IAmountDiscount,
  IDiscount,
  IPercentageDiscount,
} from '@/common/integrations/menhir/employee/discounts/discounts.types';
import { LanguageType } from '@/common/types/general';
import {
  IMenhirAmountDiscount,
  IMenhirDiscount,
  IMenhirDiscountPromoCode,
  IMenhirDiscountProviderInfos,
  IMenhirPercentageDiscount,
} from '@/common/types/menhir/discounts';

const isMenhirAmountDiscount = (
  discount: IMenhirDiscount
): discount is IMenhirAmountDiscount => {
  return discount.type === 'amount';
};

const transformConditionLinks = (
  menhirConditionLinks: NonNullable<IMenhirDiscount['conditions_links']>
): Partial<Record<LanguageType, string>> => ({
  [LANG.EN]: menhirConditionLinks.en_gb,
  [LANG.PT]: menhirConditionLinks.pt_pt,
  [LANG.IT]: menhirConditionLinks.it_it,
});

const transformCommonDiscountProperties = (
  discount: IMenhirDiscount
): IDiscount => ({
  id: discount.id,
  category: discount.category,
  logoUrl: discount.logo_url,
  partnerName: discount.partner_name,
  promoCode: discount.promo_code ? discount.promo_code : undefined,
  type: discount.type,
  conditionLinks: discount.conditions_links
    ? transformConditionLinks(discount.conditions_links)
    : undefined,
  providerInfos: discount.provider_infos
    ? transformProviderInfos(discount.provider_infos)
    : undefined,
});

const transformAmountDiscount = (
  discount: IMenhirAmountDiscount
): IAmountDiscount => ({
  ...transformCommonDiscountProperties(discount),
  amount: discount.value,
  type: 'amount',
});

const transformProviderInfos = (
  providerInfos: IMenhirDiscountProviderInfos
) => ({
  vipDistrict: {
    offerId: {
      es: providerInfos.vip_district.offer_id.es,
      pt: providerInfos.vip_district.offer_id.pt,
      it: providerInfos.vip_district.offer_id.it,
    },
  },
});

const transformPromoCode = (generatedCode: IMenhirDiscountPromoCode) => ({
  link: generatedCode.link,
  promoCode: generatedCode.promo_code,
});

const transformPercentageDiscount = (
  discount: IMenhirPercentageDiscount
): IPercentageDiscount => ({
  ...transformCommonDiscountProperties(discount),
  percentage: discount.value,
  type: 'percentage',
});

const transformDiscount = (
  discount: IMenhirDiscount
): IAmountDiscount | IPercentageDiscount =>
  isMenhirAmountDiscount(discount)
    ? transformAmountDiscount(discount)
    : transformPercentageDiscount(discount as IMenhirPercentageDiscount);

export default {
  transformPromoCode,
  transformDiscount,
};
